<div class="container-fluid mt-4 supplier-data-wrapper" #customLoadingTemplateMain>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4">
        <button class="btn btn-green btn-defBlue p-2 btn-nav"
          (click)="navigateToHome()"  tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (navigateToHome())">
          <span>
            <mat-icon svgIcon="home" alt="" class="pr-2"> </mat-icon>
          </span>
          <span class="float-right padding-top-2">
            ISA Home
          </span>
        </button>
      </div>
      <div class="center col-4"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
          class="logo-container" alt="edit"></div>
      <div class="col-4 text-right icon-align">
        <div class="row"> <app-helpsection></app-helpsection>
          <button *ngIf="!showForSupplier" class="home btn-no-border"
            (click)="navigateToHome()" title="Home" data-toggle="tooltip" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (navigateToHome())">
            <mat-icon svgIcon="home" width="17" height="15" alt="edit"
              class="icon-vertical-align"></mat-icon></button>
        </div>
      </div>
    </div>
    <button class="edit opened_all mb-4 cancel"
      (click)="closeAllSections()"
      (keydown.enter)="closeAllSections()"
      (keydown.space)="closeAllSections()"
      id="openAllSection"
      *ngIf="showBoxDownForAllSec"
      tabindex="0"
      type="button">
      <mat-icon svgIcon="downarrow" class="arrow-absolute-sm" alt=""></mat-icon>
      <mat-icon svgIcon="downarrow" class="arrow-simple-left" alt=""></mat-icon>
    </button>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 marginbtm">
      <button class="edit cancel"
        (click)="sectionCheck('group')"
        (keydown.enter)="sectionCheck('group')"
        (keydown.space)="sectionCheck('group')"
        *ngIf="showBoxDownGroup"
        tabindex="0"
        type="button">
        <mat-icon svgIcon="downarrow" class="arrow-absolute-md collapsed down_arrow_comp"
          alt=""></mat-icon>
      </button>
      <button class="edit opened_group cancel"
        (click)="sectionCheck('group')"
        (keydown.enter)="sectionCheck('group')"
        (keydown.space)="sectionCheck('group')"
        *ngIf="!showBoxDownGroup"
        tabindex="0"
        type="button">
        <mat-icon svgIcon="downarrow" class="arrow-absolute-md collapsed"
          alt=""></mat-icon>
      </button>
      <div class="backdarkblue pl-4 margin-bottom-0">
        <h5 class="font-weight-normal col ">
          <div class="row">
            <div>GROUP&nbsp;:&nbsp;</div>
            <div class="font-weight-bold">{{groupName}}</div>&nbsp;
            <button *ngIf="roleVariableHide"
              data-toggle="modal"
              data-target="#groupnameModalPopup"
              (click)="updateGroupExistsName()"
              (keydown.enter)="updateGroupExistsName()"
              (keydown.space)="updateGroupExistsName()"
              class="edit cancel"
              type="button"
              tabindex="0">
              <mat-icon class="whitecolor" svgIcon="edit"></mat-icon>
            </button>
          </div>
        </h5>
      </div>&nbsp;&nbsp;
      <div class="opened_group" id="openAllBoxgroup">
        <section class="pt-3 pb-3 section-ht-xs border-bottom-yellow">
          <div class="row m-0 align-center">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 px-2">
              <h4 class="title">GENERAL INFORMATION</h4>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="mb-2 row">
              <div class="font-weight-bold pr-2 pl-3">Group ID&nbsp;:</div>
              <div [innerHTML]="bolding(groupAllianceIdentifier)"></div>

              <div class="pl-1 edit flex-center" id="bold1">
                <mat-icon svgIcon="speechcomment"
                  alt="copy"
                  (click)="copyToClipboard(groupAllianceIdentifier)"
                  (keydown.enter)="copyToClipboard(groupAllianceIdentifier)"
                  (keydown.space)="copyToClipboard(groupAllianceIdentifier)"
                  [matTooltip]="'Copy'"
                  [ngStyle]="{'cursor': 'pointer'}"
                  [matTooltipPosition]="'above'"
                  tabindex="0">
                </mat-icon>
              </div>
            </div>
            <div class="mb-2 row">
              <div class="font-weight-bold pr-2 padding-left-15">Group Category&nbsp;:</div>
              <div class="pl-1">{{groupTypeCode}}&nbsp;</div>
              <button *ngIf="roleVariableHide"
                data-toggle="modal"
                (click)="updateGroupTypeCode()"
                (keydown.enter)="updateGroupTypeCode()"
                (keydown.space)="updateGroupTypeCode()"
                data-target="#groupUpdateCode"
                class="edit pl-2 cancel"
                tabindex="0">
                <mat-icon svgIcon="edit"></mat-icon>
              </button>
            </div>
            <div class="mb-2 row">
              <div class="status-container">
                <span class="font-weight-bold pr-2 padding-left-15">Group Status&nbsp;:</span>
                <span class="grouppill-status px-3"
                  *ngIf="groupModificationStatus !='' && groupModificationStatus!=undefined"
                  [ngStyle]="{'background':getColor(groupModificationStatus)}">
                  {{groupModificationStatus.replace("VALIDATED", "ACTIVE").replace("PENDING_VALIDATION",
                  "PENDING").replace("ACTIVE", "Active")}}</span>&nbsp;
                <button *ngIf="roleVariableHide"
                  data-toggle="modal"
                  (click)="updateGroupExistsStatus()"
                  (keydown.enter)="updateGroupExistsStatus()"
                  (keydown.space)="updateGroupExistsStatus()"
                  data-target="#groupStatusModalPopup"
                  class="edit cancel"
                  tabindex="0">
                  <mat-icon svgIcon="edit"></mat-icon>
              </button>
                <span class="font-weight-bold padding-left-4">
                  {{dateDisplay}}
                </span>
              </div>
            </div>

            <div class="mb-2 row padding-left-15" *ngIf="groupAlias && groupAlias.length > 0">
              <ng-container *ngFor="let groupAlia of groupAlias">
                <span class="font-weight-bold">{{ groupAlia.groupIdentifierKeyName.replace('MDM GROUP', 'Group Short
                  Name') }}:</span>
                <span class="pl-1">{{ groupAlia.value }}</span>
                <button *ngIf="roleVariableHide && groupAlia.disableEdit"
                  class="col edit pl-2 cancel"
                  data-toggle="modal"
                  data-target="#EditGrpAlias"
                  (click)="EditAlias(groupAlia.groupIdentifierKeyName,groupAlia.value, groupAlia.row_id)"
                  (keydown.enter)="EditAlias(groupAlia.groupIdentifierKeyName,groupAlia.value, groupAlia.row_id)"
                  (keydown.space)="EditAlias(groupAlia.groupIdentifierKeyName,groupAlia.value, groupAlia.row_id)"
                  type="button">
                  <mat-icon svgIcon="edit" alt="edit"></mat-icon>
                </button>
              </ng-container>
            </div>

            <div class="mb-2 row" *ngIf="showForSupplier && showBuyerProfile == true">
              <div class="status-container">
                <span class="font-weight-bold padding-left-15">BvD ID&nbsp;:</span>
                <div class="pl-1">{{sitebvidid ? sitebvidid : '--'}} </div>
                <div *ngIf="showArchivedBvdId==true && sitebvidid!=''">
                  <span class="grouppill-status px-3 py-1" [ngStyle]="{'background' : '#CB4B32'}">Archived</span>
                </div>
                <mat-icon *ngIf="noSiteAssn==true && siteAssociated==true && roleVariableHide"
                  svgIcon="edit"
                  class="img-btn pl-1 edit"
                  role="button"
                  (click)="resetBvdId('modal')"
                  (keydown.enter)="resetBvdId('modal')"
                  (keydown.space)="resetBvdId('modal')"
                  tabindex="0"
                  data-target="#openEditBvdModal"
                  data-toggle="modal">
                </mat-icon>
                <span class="pl-1"
                  *ngIf="(showForSupplier==true && groupId != '' && groupId != undefined && groupId != '' && sitebvidid!='') &&
                      showBuyerProfile == true && showForConsult == true">
                  <label class="switch m-0" for="sliderCheckBox">
                    <input type="checkbox" id="sliderCheckBox"
                      [disabled]="roleVariableHide==false || inPortfolioLoading==true"
                      (change)="toggleInPortfolioSwitch($event)" title="In Portfolio">
                    <span class="slider round" id="clickForSliderJ"></span>
                  </label>&nbsp;
                  <span>({{countValue}})</span>
                  <span class="pl-1" *ngIf="inPortfolioLoading==true"><img src="assets/images/loading.gif"
                      alt="Updating..."></span>
                </span>
              </div>
            </div>
            <br /><br />
          </div>
        </section>


        <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow">
          <div class="row m-0 pt-3 align-center">
            <div class="col col-12 col-sm-8 col-md-9 col-lg-9 col-xl-9 p-0 px-2">
              <a (click)="toggleGroupContacts()"
                (keydown.enter)="toggleGroupContacts()"
                (keydown.space)="toggleGroupContacts()"
                class="title link-underlined" tabindex="0">
                GROUP CONTACTS ({{GroupContacts?.length || 0}})
              </a>
              <a [href]="pdfLink" target="_blank"
                class="link-red">
                Personal Data Protection
              </a>
            </div>


            <div class="col col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              <button type="button" data-toggle="modal" data-target="#AddGrpContacts"
                class="btn btn-green btn-custom btn-blue float-right d-flex align-center btn-add-contact"
                (click)="AddEditGrpContact('load')"
                *ngIf="showForConsult" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (AddEditGrpContact('load'))">
                <mat-icon svgIcon="add" class="img-btn"></mat-icon><span class="float-right"> Add Group Contact</span>
              </button>
            </div>
          </div>

          <div *ngIf="showGroupContactsBlock" class="row m-0">
            <div class="table-responsive mt-3 scroll-table-section">
              <table class="table table-sm m-0">
                <thead>
                  <tr>
                    <th class="cdwidth15 th-left-align">First Name</th>
                    <th class="cdwidth15 th-left-align">Last Name</th>
                    <th class="cdwidth20 th-left-align">E-mail</th>
                    <th class="th-left-align">IPN</th>
                    <th class="cdwidth17 th-left-align th-width-150">Role</th>
                    <th class="cdwidth13 th-left-align th-width-15-px">Cellphone</th>
                    <th class="cdwidth15 th-left-align th-width-15-px">Phone</th>
                    <th class="cdwidth2 th-left-align"></th>
                  </tr>
                </thead>

                <tbody *ngIf="GroupContacts.length>0">
                  <tr *ngFor="let comCont of GroupContacts">
                    <td>{{comCont.personFirstName ? comCont.personFirstName : ''}}</td>
                    <td class="font-weight-bold label-darkblue"
                      data-toggle="modal"
                      data-target="#openContactDetails"
                      *ngIf="superusershow==true"
                      (click)="AddEditGrpContact('edit',comCont.rowId)"
                      (keydown.enter)="AddEditGrpContact('edit',comCont.rowId)"
                      (keydown.space)="AddEditGrpContact('edit',comCont.rowId)"
                      tabindex="0"class="clickable-cell">
                      {{comCont.personLastName ? comCont.personLastName : '' }}
                    </td>
                    <td *ngIf="roleVariableHide || showBuyerProfile || roleIsManager==true || showForConsult == true ">
                      {{comCont.personLastName ? comCont.personLastName : '' }}</td>
                    <td>{{PersonDetails[comCont.personRowId+'_email'] ? PersonDetails[comCont.personRowId+'_email'] : ''
                      }}</td>
                    <td>
                      <ng-container
                        *ngIf="personIpn[comCont.personRowId] && !personIpn[comCont.personRowId].archived &&
                        (!personIpn[comCont.personRowId].endDate || personIpn[comCont.personRowId].endDate >= today); else emptyIpn">
                        {{personIpn[comCont.personRowId].loginId}}</ng-container>
                      <ng-template #emptyIpn></ng-template>
                    </td>
                    <td>{{comCont.roleTypeLabel ? comCont.roleTypeLabel : '' }}
                      <span *ngIf="superusershow==true">
                        <mat-icon svgIcon="edit"
                          alt="edit"
                          width="14"
                          height="15"
                          data-toggle="modal"
                          data-target="#EditGrpConRole"
                          (click)="AddEditGrpContact('edit',comCont.rowId)"
                          (keydown.enter)="AddEditGrpContact('edit',comCont.rowId)"
                          (keydown.space)="AddEditGrpContact('edit',comCont.rowId)"
                          tabindex="0">
                        </mat-icon>
                      </span>
                    </td>
                    <td>{{PersonDetails[comCont.personRowId+'_p'] ? PersonDetails[comCont.personRowId+'_p'] : ''}}</td>
                    <td>{{PersonDetails[comCont.personRowId+'_f'] ? PersonDetails[comCont.personRowId+'_f'] : ''}}</td>
                    <td *ngIf="showForConsult == true">
                      <mat-icon svgIcon="edit"
                        alt="edit"
                        width="14"
                        height="15"
                        data-toggle="modal"
                        data-target="#openContactAndRole"
                        (click)="AddEditGrpContact('edit',comCont.rowId)"
                        (keydown.enter)="AddEditGrpContact('edit',comCont.rowId)"
                        (keydown.space)="AddEditGrpContact('edit',comCont.rowId)"
                        tabindex="0">
                      </mat-icon>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="GroupContacts.length==0">
                  <tr>
                    <td colspan="7" class="font-weight-bold label-darkblue text-center">No Results</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 marginbtm">
      <button class="edit cancel"
        (click)="sectionCheck('comp')"
        (keydown.enter)="sectionCheck('comp')"
        (keydown.space)="sectionCheck('comp')"
        *ngIf="showBoxDowncompany"
        tabindex="0"
        type="button">
        <mat-icon svgIcon="downarrow" class="arrow-absolute-md collapsed down_arrow_comp"
          alt=""></mat-icon>
      </button>
      <button class="edit opened_comp cancel"
        (click)="sectionCheck('comp')"
        (keydown.enter)="sectionCheck('comp')"
        (keydown.space)="sectionCheck('comp')"
        *ngIf="!showBoxDowncompany"
        type="button"
        tabindex="0">
        <mat-icon svgIcon="downarrow" class="arrow-absolute-md collapsed"
          alt=""></mat-icon>
      </button>
      <div class="backblue">
        <h5 class="font-weight-normal col">COMPANIES&nbsp;:&nbsp;<span
            class="font-weight-bold" *ngIf="!companyFiltered">({{getVisibleCompaniesCount()}})</span><span
            class="font-weight-bold" *ngIf="companyFiltered">({{getVisibleCompaniesCount()}} out of {{getTotalCompaniesCount()}})
          </span></h5>
      </div>&nbsp;&nbsp;
      <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow opened_group"
        id="openAllBoxcompany">
        <div class="row m-0 pt-3 align-center">
          <div class="col col-12 col-sm-4 col-md-5 col-lg-5 col-xl-5 p-0 px-2">
            <h4 class="title">COMPANIES
            </h4>
          </div>

          <div class="col col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 text-right">
            <button type="button" *ngIf="roleVariableHide && superUserShow" [disabled]="disableCheckGrpRep==true"
              class="btn btn-custom btn-purple mr-1" (click)="checkGrpRep()">
              Check Group representative
            </button>

            <button type="button" *ngIf="superUserShow==true" class="btn btn-custom btn-purple mr-1"
              (click)="clearGrpRep()">
              Clear Group representative
            </button>

            <button type="button" *ngIf="roleVariableHide" class="btn btn-custom btn-darkred" (click)="setAsGroupRep()">
              Set as Group representative
            </button>
          </div>
        </div>

        <div class="row m-0">
          <div class="table-responsive mt-3 fixTableFoot table-overflow-visible" id="company_table">
            <table class="table table-sm m-0">
              <thead>
                <tr>
                  <th class="th-width-0"></th>
                  <th class="th-left-align th-width-11">Company Name</th>
                  <th class="th-left-align th-width-3">Company Short Name</th>
                  <th class="th-left-align th-width-2">Status
                    <span>
                      <div class="dropdown dropdown-inline">
                        <button class="edit cancel"
                          type="button"
                          id="dropdownMenuButton"
                          (click)="showDropdownStatus()"
                          (keydown.enter)="showDropdownStatus()"
                          (keydown.space)="showDropdownStatus()"
                          tabindex="0">
                          <mat-icon *ngIf="companyFiltered" svgIcon="filter-1" class="img-btn img-btn-sm"></mat-icon>
                          <mat-icon *ngIf="!companyFiltered" svgIcon="filter-2" class="img-btn img-btn-sm"></mat-icon>
                        </button>
                      </div>
                    </span>
                    <div *ngIf="showFilterStatus"
                      class="dropdown-menu-custom">
                      <ng-container class="bg-white">
                        <ul class="row m-0 nav list-view p-0 pt-1 filter-list">
                          <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 filter-item" *ngFor="let status of statusOrder">
                            <label for="company-{{status}}">
                              <input type="checkbox"
                                id="company-{{status}}"
                                (click)="setCheckboxVal(status)"
                                (keydown.enter)="setCheckboxVal(status)"
                                (keydown.space)="setCheckboxVal(status)"
                                value="{{status}}"
                                class="edit checkboxAt"
                                tabindex="0">&nbsp;&nbsp;
                              <span class="group-status-1" [ngStyle]="{'background':getColor2(status)}">
                                {{status}}
                              </span>
                            </label>
                          </li>
                        </ul>
                        <div class="modal-footer py-0 pr-0 border-0 mt-2">
                          <button type="button" class="btn btn-custom btn-link btn-transparent"
                            (click)="showDropdownStatus('close')">Clear</button>
                          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
                            (click)="filterStatus()">OK</button>
                        </div>
                      </ng-container>
                    </div>
                  </th>
                  <th class="th-left-align th-width-4">Company ID</th>
                  <th *ngIf="showForSupplier" class="th-left-align th-width-3">BvD ID</th>
                  <th class="th-left-align th-width-0">Supplier code (COFOR)</th>
                  <th class="th-left-align th-width-7">Country</th>
                  <th class="th-left-align th-width-1">City</th>
                </tr>
              </thead>

              <tbody *ngIf="companyGroupSection && companyGroupSection.length>0" #customLoadingTemplatecompany>
                <tr class="table-row-height" *ngIf="showEmptyRow">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td *ngIf="roleVariableHide == true"></td>
                </tr>
                <tr *ngFor="let companyGroupSec of companyGroupSection;let i = index">
                  <ng-container *ngIf="companyGroupSec.hideRow==false &&  companyGroupSec.filterTrue == true">
                    <td>
                      <span
                        *ngIf="companyGroupSec.showInput && companyGroupSec.apoStatus &&
                        companygroupsecstatus[companyGroupSec.companyAllianceIdentifier] && roleVariableHide==true">
                              <label for="'company-rep-' + companyGroupSec.companyId" class="sr-only">
                                Select {{companyGroupSec.companyAllianceLegalName}} as group representative
                              </label>
                              <input type="radio" class="edit"
                          *ngIf="companyGroupSec.apoStatus.toLowerCase() == 'active' &&
                          companygroupsecstatus[companyGroupSec.companyAllianceIdentifier].toLowerCase()"
                          id="'company-rep-' + companyGroupSec.companyId"
                          name="cpySectionInput"
                          (click)="changeSelection(companyGroupSec.companyId)"
                          (keydown.enter)="changeSelection(companyGroupSec.companyId)"
                          (keydown.space)="changeSelection(companyGroupSec.companyId)"
                          value="{{companyGroupSec.companyId}}"
                          [(ngModel)]="selectedCpyRep"
                          tabindex="0">
                      </span>
                      <span *ngIf="companyGroupSec.isGrpRep == true">
                        <mat-icon class="pr-0 py-0 icon-size-standard"
                          svgIcon="{{sortedQualifiers['P18']}}" alt=""></mat-icon>
                      </span>
                    </td>
                    <td class="font-weight-bold label-darkblue"><a class="font-weight-bold label-darkblue"
                        [routerLink]="['/company-details',companyGroupSec.companyId]">{{companyGroupSec.companyAllianceLegalName}}</a>
                    </td>
                    <td class="companyShortName">{{companySectionShortNameArr[companyGroupSec.companyId] ?
                      companySectionShortNameArr[companyGroupSec.companyId].value : '--'}}</td>
                    <td>
                      <div class="group-status-1 firstletteruppercase"
                        *ngIf="companygroupsecstatus[companyGroupSec.companyAllianceIdentifier] !='' &&
                        companygroupsecstatus[companyGroupSec.companyAllianceIdentifier]!=undefined"
                        [ngStyle]="{'background':getColor2(companygroupsecstatus[companyGroupSec.companyAllianceIdentifier])}">
                        {{companygroupsecstatus[companyGroupSec.companyAllianceIdentifier]}}</div>
                    </td>
                    <td>{{companyGroupSec.companyAllianceIdentifier}}</td>
                    <td *ngIf="showForSupplier">{{companygroupsecmaintaxidenti[companyGroupSec.companyId]}}</td>
                    <td>
                      <span *ngIf="alcorCodesOnCpyIds[companyGroupSec.companyId]">
                        <ul class="row m-0 nav list-view p-0"
                          *ngFor="let alcors of alcorCodesOnCpyIds[companyGroupSec.companyId]">
                          <li>{{alcors}}</li>
                        </ul>
                      </span>
                    </td>
                    <td>
                      <span *ngIf="siteCityAndCountryHQ[companyGroupSec.companyId]">
                        {{siteCityAndCountryHQ[companyGroupSec.companyId].countryName ?
                        siteCityAndCountryHQ[companyGroupSec.companyId].countryName : '--'}}
                      </span>
                    </td>
                    <td>
                      <span *ngIf="siteCityAndCountryHQ[companyGroupSec.companyId]">
                        {{siteCityAndCountryHQ[companyGroupSec.companyId].cityName ?
                        siteCityAndCountryHQ[companyGroupSec.companyId].cityName : '--'}}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="companyGroupSec.hideRow==true && companyGroupSection.length==1">
                    <td colspan="12" class="font-weight-bold label-darkblue text-center">
                      No Results
                    </td>
                  </ng-container>
                </tr>
              </tbody>
              <tbody *ngIf="companyGroupSection && companyGroupSection.length<=0">
                <tr *ngIf="!companyFiltered">
                  <td colspan="10" class="font-weight-bold label-darkblue text-center"> No Company.</td>
                </tr>
                <tr *ngIf="companyFiltered">
                  <td colspan="10" class="font-weight-bold label-darkblue text-center"> No Company in {{statuses}}
                    status.</td>
                </tr>
              </tbody>
              <tfoot *ngIf="companyGroupSection && companyGroupSection.length>0 && pager.pages && pager.pages.length>1">
                <tr>
                  <td colspan="12">
                    <ul *ngIf="pager.pages && pager.pages.length && paginationForStatus==false" class="pagination">
                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="getCompanyGroupSection(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getCompanyGroupSection(1))">First</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="getCompanyGroupSection(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getCompanyGroupSection(pager.currentPage - 1))">Previous</a>
                      </li>
                      <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="getCompanyGroupSection(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getCompanyGroupSection(page))">{{page}}</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="getCompanyGroupSection(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getCompanyGroupSection(pager.currentPage + 1))">Next</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="getCompanyGroupSection(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getCompanyGroupSection(pager.totalPages))">Last</a>
                      </li>
                    </ul>
                    <ul *ngIf="pager.pages && pager.pages.length && paginationForStatus==true" class="pagination">
                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(1))">First</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(pager.currentPage - 1))">Previous</a>
                      </li>
                      <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(page))">{{page}}</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(pager.currentPage + 1))">Next</a>
                      </li>
                      <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(pager.totalPages))">Last</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
              <ng-container *ngIf="loading1">
                <div class="local-loading-overlay">
                  <div class="custom-spinner-template">
                    <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                  </div>
                </div>
              </ng-container>
            </table>
          </div>
        </div>
      </section>
    </div>

    <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <button class="edit cancel"
        (click)="sectionCheck('site')"
        (keydown.enter)="sectionCheck('site')"
        (keydown.space)="sectionCheck('site')"
        *ngIf="showBoxDownSite"
        tabindex="0"
        type="button">
        <mat-icon svgIcon="downarrow" class="arrow-absolute-md collapsed down_arrow_comp"
          alt=""></mat-icon>
      </button>
      <button class="edit opened_comp cancel"
        (click)="sectionCheck('site')"
        (keydown.enter)="sectionCheck('site')"
        (keydown.space)="sectionCheck('site')"
        *ngIf="!showBoxDownSite"
        tabindex="0"
        type="button">
        <mat-icon svgIcon="downarrow" class="arrow-absolute-md collapsed"
          alt=""></mat-icon>
      </button>
      <div class="backblue">
        <h5 class="font-weight-normal col">SITES&nbsp;:&nbsp;<span
            class="font-weight-bold" *ngIf="!siteFiltered">({{getVisibleSitesCount()}})</span><span
            class="font-weight-bold" *ngIf="siteFiltered">({{getVisibleSitesCount()}} out of {{getTotalSitesCount()}})</span></h5>
      </div>&nbsp;&nbsp;
      <section class="co l col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 border-bottom-yellow" id="openAllBoxcsite">
        <div class="row m-0 pt-3 align-center">
          <div class="col col-12 col-sm-2 col-md-1 col-lg-3 col-xl-4 p-0 px-2">
            <h4 class="title">SITES
            </h4>
          </div>
        </div>

        <div class="row m-0">
          <div class="table-responsive mt-3 fixTableFoot table-overflow-visible" id="site_table">
            <table class="table table-sm tbl-custom m-0">

              <thead>
                <tr>
                  <th class="th-width-0"></th>
                  <th class="th-left-align th-width-22">Site Name</th>
                  <th class="th-left-align th-width-10">Site Status
                    <span>
                      <div class="dropdown dropdown-inline">
                        <button class="edit cancel"
                          type="button"
                          id="dropdownMenuButton4"
                          (click)="showDropdownStatusForSites()"
                          (keydown.enter)="showDropdownStatusForSites()"
                          (keydown.space)="showDropdownStatusForSites()"
                          tabindex="0">
                          <mat-icon *ngIf="siteFiltered" svgIcon="filter-1" class="img-btn img-btn-sm"></mat-icon>
                          <mat-icon *ngIf="!siteFiltered" svgIcon="filter-2" class="img-btn img-btn-sm"></mat-icon>
                        </button>
                      </div>
                    </span>
                    <div *ngIf="showFilterStatusForSites" data-toggle="modal"
                      class="dropdown-menu-sites">
                      <ng-container class="bg-white">
                        <ul class="row m-0 nav list-view p-0 pt-1 filter-list-sites">
                          <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 filter-item"
                            *ngFor="let status of statusOrderForSites">
                            <label for="sites-{{status}}">
                              <input type="checkbox"
                                id="sites-{{status}}"
                                [checked]="statusesForSites && statusesForSites.includes(status)"
                                (click)="setCheckboxValForSites(status)"
                                (keydown.enter)="setCheckboxValForSites(status)"
                                (keydown.space)="setCheckboxValForSites(status)"
                                value="{{status}}" class="edit checkboxAt" tabindex="0">&nbsp;&nbsp;
                              <span class="group-status-1" [ngStyle]="{'background':getColor2ForSites(status)}">
                               {{ status.replace("Created", "Identified").replace("Pending","Inactive").replace("ACTIVE","Active") }}
                              </span>
                            </label>
                          </li>
                        </ul>
                        <div class="modal-footer py-0 pr-0 border-0 mt-2">
                          <button type="button" class="btn btn-custom btn-link btn-transparent"
                            (click)="showDropdownStatusForSites('close')">Clear</button>
                          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
                            (click)="filterStatusForSites()">OK</button>
                        </div>
                      </ng-container>
                    </div>
                  </th>
                  <th class="th-left-align th-width-10">Site ID</th>
                  <th *ngIf="roleVariableHide" class="th-left-align th-width-10">Bvd ID</th>
                  <th class="th-left-align th-width-10">C2B</th>
                  <th class="th-left-align th-width-8">RAFT/SAER/LATAM</th>
                  <th class="th-left-align th-width-15">Address</th>
                  <th class="th-left-align th-width-10 z-index-1">Qualifiers</th>
                </tr>
              </thead>

              <tbody *ngIf="SitesInfo.length>0 && SiteDispLoading==false">
                <tr *ngIf="noHqExists=='no' || noHqExists=='multiple' || siteBusinessEntityExist==false">
                  <td *ngIf="noHqExists=='no'"><mat-icon class="pr-0 py-0 icon-size-standard"
                      svgIcon="{{sortedQualifiers['P18']}}"
                      alt=""></mat-icon></td>
                  <td *ngIf="noHqExists=='multiple'" colspan="7" class="font-weight-bold label-orange text-center">More
                    than one headquarters</td>
                </tr>
                <tr *ngFor="let siteinf of SitesInfo">
                  <ng-container *ngIf="siteinf.showRow==true &&  siteinf.filterTrue == true">
                    <td>
                      <span *ngIf="siteinf.businessEntityId">
                        <span *ngIf="siteinf.isHQ=='N' && siteinf.businessEntityId != '' && roleVariableHide==true">
                          <span></span>
                        </span>
                        <span *ngIf="siteinf.isHQ=='Y'">
                          <mat-icon class="pr-0 py-0 icon-size-standard"
                            svgIcon="{{sortedQualifiers['P18']}}" alt=""></mat-icon>
                        </span>
                      </span>
                    </td>
                    <td class="font-weight-bold label-darkblue cell-width-16">
                      <a *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]" class="label-darkblue"
                        [routerLink]="['/site-details/'+Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ['rowId']]+'/'+siteinf.businessEntityCompanyId">
                        {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ? Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['name'] : 'No Site' }}</a>
                    </td>
                    <td>
                      <span class="group-status" *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]"
                        [ngStyle]="
                        {'background':colorStatus[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ['activeStatus'].toLowerCase()],'min-width': '82px','float': 'left' }">
                        {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] ?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['activeStatus'].replace("CREATED","Identified").replace("PENDING","Inactive").replace("ACTIVE","Active") : '' }}
                      </span>
                    </td>
                    <td>
                      {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] ?
                      Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]].identifier : ''}}
                    </td>
                    <td *ngIf="roleVariableHide">
                      {{SiteDe_BvdID_Stat[siteinf.businessEntityId] ?
                      SiteDe_BvdID_Stat[siteinf.businessEntityId]['value'] : ''}}
                    </td>
                    <td class="cell-max-width-200">
                      <span
                        *ngIf="
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']:false">
                        <ul class="row m-0 nav list-view p-0"
                          *ngFor="let
                          c2b of sitec2bCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]">
                          <li class="list-view-item">{{c2b}}</li>
                        </ul>
                      </span>
                    </td>
                    <td class="cell-max-width-200">
                      <span
                        *ngIf="
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']:false">
                        <ul class="row m-0 nav list-view p-0"
                          *ngFor="let rafts of siteRaftCodeValOnRowId
                          [Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]">
                          <li class="list-view-item">R: {{rafts}}</li>
                        </ul>
                      </span>
                      <span
                        *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']:false">
                        <ul class="row m-0 nav list-view p-0"
                          *ngFor="let saer of sitesaerCodeValOnRowId
                          [Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]">
                          <li class="list-view-item">S: {{saer}}</li>
                        </ul>
                      </span>

                      <span
                        *ngIf="Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']:false">
                        <ul class="row m-0 nav list-view p-0"
                          *ngFor="
                          let latam of siteLatamCodeValOnRowId[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['identifier']]">
                          <li class="list-view-item">L: {{latam}}</li>
                        </ul>
                      </span>
                    </td>
                    <td>
                      <span class="font-italic font-size-smaller">
                        {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] &&
                        acpAddressDetOnRows[accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]]
                        ?(acpAddressDetOnRows[accessPointIdOnAddress
                        [Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]].wayNumber?
                        acpAddressDetOnRows[accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                        ['rowId']]].wayNumber
                        + ',' : '') : ''}}
                        {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] &&
                        acpAddressDetOnRows[accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]]
                        ?(acpAddressDetOnRows[accessPointIdOnAddress
                        [Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]].streetName?
                        acpAddressDetOnRows[accessPointIdOnAddress
                        [Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]].streetName+
                        (acpAddressDetOnRows[accessPointIdOnAddress
                        [Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]].additionalInformation
                        ? ',' : '') : '') : ''}}
                        <div>
                          {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] &&
                          acpAddressDetOnRows[accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['rowId']]]
                          ?acpAddressDetOnRows
                          [accessPointIdOnAddress[Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]
                          ['rowId']]].additionalInformation
                          : ''}}
                        </div>
                      </span>
                      <div class="font-weight-bold">
                        {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] ?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['cityName'] : '' }}
                      </div>
                      <div class="font-weight-bold">
                        {{Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]] ?
                        Site_City_Country[Site_hrefTo_Cid[siteinf.businessEntityId]]['countryName'] : '' }}
                      </div>
                    </td>
                    <td class="cell-width-30">
                      <ng-container *ngIf="site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]]">
                        <div class="row">
                          <span class="p-0" *ngFor="let some of sortedQualifiers | keyvalue : returnZero">
                            <div class="col p-0 m-0"
                              *ngIf="
                              site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key]">
                              <div class="icon-container p-0 m-0">
                                <span class="main-icon">
                                  <mat-icon class="icon-size-standard qualifer-icons pr-1 pl-1 pt-3 pb-0"
                                    title="{{site_qualifiers[Site_hrefTo_Cid
                                      [siteinf.businessEntityId]][some.key] ? qualifierTypesText[some.key] : ''}}"
                                    data-toggle="tooltip"
                                    svgIcon="{{site_qualifiers[Site_hrefTo_Cid
                                      [siteinf.businessEntityId]][some.key] ? some.value : sortedQualifiers['P100']}}"
                                   ></mat-icon>
                                </span>
                                <span class="superscript-icon superscript-icon-position"
                                  *ngIf="site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key] &&
                                  site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key] != 1"
                                  [style.background-color]="qualifierColors[some.key]">
                                  {{site_qualifiers[Site_hrefTo_Cid[siteinf.businessEntityId]][some.key]}}
                                </span>
                              </div>
                            </div>
                          </span>
                        </div>
                      </ng-container>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="siteinf.showRow==false && SitesInfo.length ==1">
                    <td colspan="2" class="font-weight-bold label-darkblue text-center">No Sites</td>
                  </ng-container>
                </tr>
              </tbody>

              <tbody *ngIf="SitesFlag==true && SitesInfo.length==0">
                <tr>
                  <td colspan="12" class="font-weight-bold label-darkblue text-center">No Results</td>
                </tr>
              </tbody>
              <tfoot
                *ngIf="tempSiteSection && tempSiteSection.length>0 && paging.pages && paging.pages.length>1 && SiteDispLoading==false">
                <tr>
                  <td colspan="12">
                    <ul *ngIf="paging.pages && paging.pages.length" class="pagination">
                      <li [ngClass]="{disabled:paging.currentPage === 1}">
                        <a (click)="setPageForSitesSec(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(1))">First</a>
                      </li>
                      <li [ngClass]="{disabled:paging.currentPage === 1}">
                        <a (click)="setPageForSitesSec(paging.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(paging.currentPage - 1))">Previous</a>
                      </li>
                      <li *ngFor="let page of paging.pages" [ngClass]="{active:paging.currentPage === page}">
                        <a (click)="setPageForSitesSec(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(page))">{{page}}</a>
                      </li>
                      <li [ngClass]="{disabled:paging.currentPage === paging.totalPages}">
                        <a (click)="setPageForSitesSec(paging.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(paging.currentPage + 1))">Next</a>
                      </li>
                      <li [ngClass]="{disabled:paging.currentPage === paging.totalPages}">
                        <a (click)="setPageForSitesSec(paging.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPageForSitesSec(paging.totalPages))">Last</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>

            <div class="text-center-loading" *ngIf="SiteDispLoading==true || SitesFlag==false">
              <img src="assets/images/loading.gif" alt="loading...">
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

</div>
<ng-container *ngIf="loading">
  <div class="local-loading-overlay">
    <div class="custom-spinner-template">
      <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
    </div>
  </div>
</ng-container>

<div class="modal fade" id="EditGrpAlias" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Edit Group Alias by Admin
          <button type="button" class="close" id="closeEditGrpAlias" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="characterLimitForEdit"> {{EditAliasObj.AliasType}}
            </label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="EditAliasModel"
              id="characterLimitForEdit" (keyup)="EditAliasEmptyCheck()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button class="ng-clear cancel"
                (click)="resetEditAliasValue()"
                (keydown.enter)="resetEditAliasValue()"
                (keydown.space)="resetEditAliasValue()"
                tabindex="0">×
            </button>
            </span>
            <span class="text-error" *ngIf="EditGrpAlliasValueError==true">Please enter the value.</span>
            <span class="text-error" *ngIf="EditGrpAlliasCharacterLimitError==true">Max Character for MDM ALIAS is
              6 !!!.</span>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 modal-section-full-width">
          <button type="button" class="btn btn-custom btn-custom-sm mr-2 bg-red" data-toggle="modal"
            (click)="closeExistsGroupAliasPopup(EditAliasObj.AliasType)" data-target="#groupAliasDeleteModalPopup">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete</span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-toggle="modal"
            (click)="closeExistsGroupAliasPopup(EditAliasObj.AliasType)" data-target="#groupAliasRemoveModalPopup">
            Archive
          </button>
          <div class="float-right-container">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
              [disabled]="disableEditGrpAliasBtn==true" (click)="EditSaveGrpAllias(EditAliasObj.AliasType)">
              <mat-icon svgIcon="mail" class="img-btn mr-2 icon-size-small"></mat-icon><span
                class="float-right">{{saveDatas}}</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="createMailModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel2">
          Reminder
          <button type="button" class="close" id="closeCCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="reminderNotes">
              <h4 class="title px-2">Reminder Notes</h4>
            </label>
            <textarea rows="3" cols="60" id="reminderNotes" [(ngModel)]="MailNameModel">
            </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button"
                class="ng-clear cancel"
                (click)="resetCompanyNameFields()"
                (keydown.enter)="resetCompanyNameFields()"
                (keydown.space)="resetCompanyNameFields()" tabindex="0">×
              </button>
            </span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button class="btn btn-custom btn-blue float-right mr-2 mb-4 btn-rounded-right">
            Send to Approver</button>
          <button class="btn btn-custom btn-blue float-right pr-0 btn-rounded-left">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-size-small"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="AddGrpContacts" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel3">
          Add Group Contact
          <button type="button" class="close" id="closeGrpContacts" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <div class="mb-2 pl-3"> <span class="font-weight-bold">Group : </span> {{ groupName ? groupName : '' }}</div>
        <section class="row m-0 bg-white no-shadow">

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="grpConEmailAdd">Email<span class="text-error">*</span></label>
            <input type="email" class="form-control form-control-sm" id="grpConEmailAdd" [(ngModel)]="GrpConEmail"
              (change)="checkEmailChanged()" (keyup)="GrpCntemptyCheck('Email')" [disabled]="disableEmail==true">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button"
                class="ng-clear cancel"
                (click)="resetGrpContact('Email')"
                (keydown.enter)="resetGrpContact('Email')"
                (keydown.space)="resetGrpContact('Email')" tabindex="0">×
              </button>
            </span>
            <span class="text-error" *ngIf="GrpConEmailError==true">Please Enter the Email.</span>
            <span class="text-error" *ngIf="GrpConEmailFormatError==true">Please Enter a Valid Email.</span>
          </div>

          <div class="mb-2 pl-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="grp_modelLabelName"> <span
              class="font-weight-bold">Name : </span> {{ grpModelName}} </div>
          <div class="mb-2 pl-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="grp_modelIpn"> <span
              class="font-weight-bold">IPN : </span> {{ grpModelIpn }} </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="grp_modelFname">
            <label class="label-control" for="grpConFnameAdd">First Name<span class="text-error">*</span></label>
            <input type="text" autocomplete="off" class="form-control form-control-sm" id="grpConFnameAdd" [(ngModel)]="GrpConFname"
              (keyup)="GrpCntemptyCheck('Fname')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button"
                class="ng-clear cancel"
                (click)="resetGrpContact('Fname')"
                (keydown.enter)="resetGrpContact('Fname')"
                (keydown.space)="resetGrpContact('Fname')" tabindex="0">×
              </button>
            </span>
            <span class="text-error" *ngIf="GrpConFnameError==true">Please Enter the First Name.</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" *ngIf="grp_modelLname">
            <label class="label-control" for="grpConLnameAdd">Last Name<span class="text-error">*</span></label>
            <input type="text" class="form-control form-control-sm" id="grpConLnameAdd" [(ngModel)]="GrpConLname"
              (keyup)="GrpCntemptyCheck('Lname')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button class="ng-clear cancel"
                (click)="resetGrpContact('Lname')"
                (keydown.enter)="resetGrpContact('Lname')"
                (keydown.space)="resetGrpContact('Lname')"
                tabindex="0">×
            </button>
            </span>
            <span class="text-error" *ngIf="GrpConLnameError==true">Please Enter the Last Name.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="grp_modelCellphone">
            <label class="label-control" for="grpConCellphone">Cellphone
            </label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="GrpConCellphone"
              id="grpConCellphone" (keyup)="GrpCntemptyCheck('Cellphone')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Cellphone')"
                (keydown.enter)="resetGrpContact('Cellphone')"
                (keydown.space)="resetGrpContact('Cellphone')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConCellphoneError==true">Please Enter the Cellphone value.</span>
            <span class="text-error" *ngIf="GrpConCellphoneError2==true">Cellphone value is not valid.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="grp_modelPhone">
            <label class="label-control" for="grpConPhone">Phone
            </label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="GrpConPhone"
              id="grpConPhone" (keyup)="GrpCntemptyCheck('Phone')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Phone')"
                (keydown.enter)="resetGrpContact('Phone')"
                (keydown.space)="resetGrpContact('Phone')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConPhoneError==true">Please Enter the Phone value.</span>
            <span class="text-error" *ngIf="GrpConPhoneError2==true">Phone value is not valid.</span>
          </div>

          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12" *ngIf="grp_modelRole">
            <label class="label-control" for="grpConRoleAdd">Role<span class="text-error">*</span></label>
            <mat-select class="form-control form-control-sm dropdown-select" id="grpConRoleAdd" [(ngModel)]="GrpConRole"
              (selectionChange)="GrpCntRoleSelected($event)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <ng-container *ngIf="PersonRoleSelectOp.length>0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp"
                value="{{pRole.rowId}}">{{pRole.roleTypeLabel}}</mat-option>
            </mat-select>
            <span class="text-error" *ngIf="GrpConRoleError==true">Please Select the Role.</span>
            <span class="text-error" *ngIf="GrpConRoleexists==true">The Role already for this user</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveGrpCnt('add')"
            *ngIf="grp_ShowSave">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-size-small"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>

          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveGrpCnt('next')"
            *ngIf="grp_ShowNext">
            Next
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditGrpContacts" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel4">
          Edit Group Contact
          <button type="button" class="close" id="closeEditGrpContacts" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-3 pl-3"> <span class="font-weight-bold">Group : </span> {{ groupName ? groupName : '' }} </div>

        <div class="mb-3 pl-3"> <span class="font-weight-bold">Name : </span> {{ GrpConFname ? GrpConFname : '' }} {{
          GrpConLname ? GrpConLname : '' }} <span class="edit ml-2"> <mat-icon src="edit" alt="edit"></mat-icon> </span>
        </div>

        <div class="mb-3 pl-3"> <span class="font-weight-bold">Role : </span> {{ GrpConRole ? GrpConRole : '' }}
        </div>
        <section class="row m-0 bg-white no-shadow">

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="grpConIpn">IPN</label>
            <input type="text" class="form-control form-control-sm" id="grpConIpn" [(ngModel)]="GrpConIpn"
              (keyup)="GrpCntemptyCheck('Ipn')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Ipn')"
                (keydown.enter)="resetGrpContact('Ipn')"
                (keydown.space)="resetGrpContact('Ipn')" tabindex="0">×</button></span>
            <span class="text-error" *ngIf="GrpConIpnError==true">Please Enter the IPN.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="grpConEmailEdit">Email<span class="text-error">*</span></label>
            <input type="email" class="form-control form-control-sm" id="grpConEmailEdit" [(ngModel)]="GrpConEmail"
              (keyup)="GrpCntemptyCheck('Email')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear"><button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Email')"
                (keydown.enter)="resetGrpContact('Email')"
                (keydown.space)="resetGrpContact('Email')" tabindex="0">×</button></span>
            <span class="text-error" *ngIf="GrpConEmailError==true">Please Enter the Email.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="grpConCellphoneEdit">Cellphone
            </label>
            <input type="text" class="form-control form-control-sm" id="grpConCellphoneEdit" [(ngModel)]="GrpConCellphone"
              (keyup)="GrpCntemptyCheck('Cellphone')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Cellphone')"
                (keydown.enter)="resetGrpContact('Cellphone')"
                (keydown.space)="resetGrpContact('Cellphone')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConCellphoneError==true">Please Enter the Cellphone value.</span>
            <span class="text-error" *ngIf="GrpConCellphoneError2==true">Cellphone value is not valid.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0">
            <label class="label-control" for="grpConPhoneEdit">Phone
            </label>
            <input type="text" class="form-control form-control-sm" id="grpConPhoneEdit" [(ngModel)]="GrpConPhone"
              (keyup)="GrpCntemptyCheck('Phone')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Phone')"
                (keydown.enter)="resetGrpContact('Phone')"
                (keydown.space)="resetGrpContact('Phone')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConPhoneError==true">Please Enter the Phone value.</span>
            <span class="text-error" *ngIf="GrpConPhoneError2==true">Phone value is not valid.</span>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0 float-left-w100">
          <div class="float-left-w60">
            <button type="button" class="btn btn-custom btn-custom-sm btn-red btn-red-bg"
              data-toggle="modal" data-target="#DeleteContact">
              <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete Contact</span>
            </button>
          </div>
          <div class="float-right-w40">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveGrpCnt('edit')">
              <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
                class="float-right">{{saveDatas}}</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openContactAndRole" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel5">
          Contact
          <button type="button" class="close" id="closeContactAndRole" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-2">
          <button type="button" class="openContactAndRole" (click)="switchVisible('btn1')"
            [ngClass]="{ 'btnCss' : openData == true}">
            DATA
          </button>
          <button type="button" class="openContactAndRole" (click)="switchVisible('btn2')"
            [ngClass]="{ 'btnCss' : openRole == true}">
            ROLE
          </button>
        </div>

        <div *ngIf="openData==true">
          <div class="row mb-2 pl-3"> <span class="pr-2 font-weight-bold-pl15">Name : </span>
            <span class="pl-1">{{ GrpConFname ? GrpConFname : '' }} {{ GrpConLname ? GrpConLname : '' }}</span>
            <span class="col edit pl-2"
              *ngIf="(((roleVariableHide || roleIsManager || showBuyerProfile==false) && CmpConIpn=='') ||
              superUserShow==true || showForSupplier==false)&& endDateisPresent ==false">
              <mat-icon svgIcon="edit" alt="edit" data-toggle="modal" data-target="#editGrpConNameDetails"
                (click)="setEditConDetails('name')"
                (keydown.enter)="setEditConDetails('name')"
                (keydown.space)="setEditConDetails('name')"
                tabindex="0"></mat-icon>
            </span>
          </div>
          <div class="mb-3 pl-3"> <span class="font-weight-bold">Email : </span> {{ GrpConEmail ? GrpConEmail : '' }}
          </div>
          <div class="mb-3 pl-3" *ngIf="endDateisPresent==true"> <span class="font-weight-bold">IPN : </span>{{
            GrpConIpn ? GrpConIpn : '' }} </div>
          <div class="row mb-2 pl-3" *ngIf="cellPhoneEdit==false"> <span class="pr-2 font-weight-bold-pl15">Cellphone : </span>
            <span class="pl-1">{{ GrpConCellphone ? GrpConCellphone : '' }} </span>
            <span class="col edit pl-2"
              *ngIf="(((roleVariableHide || roleIsManager || showBuyerProfile==false) && GrpConIpn=='') ||
               superUserShow==true || showForSupplier==false)&& endDateisPresent ==false">
              <mat-icon svgIcon="edit" alt="edit"
                (click)="setEditConDetails('cellPhone')"
                (keydown.enter)="setEditConDetails('cellPhone')"
                (keydown.space)="setEditConDetails('cellPhone')"
                tabindex="0"></mat-icon>
            </span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="cellPhoneEdit==true">
            <label class="label-control font-weight-bold" for="grpConCellphone1">Cellphone : </label>
            <input type="text" class="form-control form-control-sm" id="grpConCellphone1" [(ngModel)]="GrpConCellphone"
              (keyup)="GrpCntemptyCheck('Cellphone')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Cellphone')"
                (keydown.enter)="resetGrpContact('Cellphone')"
                (keydown.space)="resetGrpContact('Cellphone')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConCellphoneError==true">Please Enter the Cellphone value.</span>
            <span class="text-error" *ngIf="GrpConCellphoneError2==true">Cellphone value is not valid.</span>
            <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-custom btn-link" (click)="toggleGrpConEdit()"> Cancel </button>
              <span>|</span>
              <button type="button" class="btn btn-custom btn-link" (click)="editGrpConDetails('phone')"> Save </button>
            </section>
          </div>

          <div class="row mb-2 pl-3" *ngIf="fixedPhoneEdit==false"> <span class="pr-2 font-weight-bold-pl15">Phone : </span>
            <span class="pl-1"> {{ GrpConPhone ? GrpConPhone : '' }} </span>
            <span class="col edit pl-2"
              *ngIf="(((roleVariableHide || roleIsManager || showBuyerProfile==false) && GrpConIpn=='') ||
              superUserShow==true || showForSupplier==false)&& endDateisPresent ==false">
              <mat-icon svgIcon="edit" alt="edit"
                (click)="setEditConDetails('fixedPhone')"
                (keydown.enter)="setEditConDetails('fixedPhone')"
                (keydown.space)="setEditConDetails('fixedPhone')"
                tabindex="0"></mat-icon>
            </span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-0" *ngIf="fixedPhoneEdit==true">
            <label class="label-control font-weight-bold" for="grpConPhone1">Phone : </label>
            <input type="text" class="form-control form-control-sm" id="grpConPhone1" [(ngModel)]="GrpConPhone"
              (keyup)="GrpCntemptyCheck('Phone')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpContact('Phone')"
                (keydown.enter)="resetGrpContact('Phone')"
                (keydown.space)="resetGrpContact('Phone')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConPhoneError==true">Please Enter the Phone value.</span>
            <span class="text-error" *ngIf="GrpConPhoneError2==true">Phone value is not valid.</span>
            <section class="bg-white no-shadow m-0 d-flex justify-content-end align-items-center">
              <button type="button" class="btn btn-custom btn-link" (click)="toggleGrpConEdit()"> Cancel </button>
              <span>|</span>
              <button type="button" class="btn btn-custom btn-link" (click)="editGrpConDetails('phone')"> Save </button>
            </section>
          </div>
        </div>

        <div *ngIf="openRole==true">
          <div class="mb-3 pl-3"> <span class="font-weight-bold">Group : </span> {{ groupName ? groupName : '' }}
          </div>
          <div class="mb-3 pl-3"> <span class="font-weight-bold">Name : </span> {{ GrpConFname ? GrpConFname : '' }}
            {{ GrpConLname ? GrpConLname : '' }}</div>
          <div class="mb-3 pl-3"> <span class="font-weight-bold">Email : </span> {{ GrpConEmail ? GrpConEmail : '' }}
          </div>
          <div class="mb-3 pl-3" *ngIf="GrpConIpn!=''"> <span class="font-weight-bold">IPN : </span> {{ GrpConIpn ?
            GrpConIpn : '' }} </div>
          <section class="row m-0 bg-white no-shadow">
            <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12">
              <mat-label class="label-control font-weight-bold">Role
              </mat-label>
              <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="GrpConRole"
                (selectionChange)="GrpCntRoleSelected($event)" panelClass="dropdown-panel"
                [disableOptionCentering]="true">
                <ng-container *ngIf="PersonRoleSelectOp.length>0"></ng-container>
                <mat-option *ngFor="let pRole of PersonRoleSelectOp"
                  value="{{pRole.rowId}}">{{pRole.roleTypeLabel}}</mat-option>
              </mat-select>
              <span class="text-error" *ngIf="GrpConRoleError==true">Please Select the Role.</span>
            </div>
          </section>
        </div>
      </div>

      <div class="modal-footer border-0 m-0" *ngIf="openData==true">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red btn-red-bg btn-margin-right-245"
            data-toggle="modal" data-target="#DeleteContact"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile==false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete Contact</span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> Close </button>
        </section>
      </div>

      <div class="modal-footer border-0 m-0" *ngIf="openRole==true">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red btn-red-bg btn-margin-right-180"
            data-toggle="modal" data-target="#groupContactRemoveModalPopup"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile==false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete Role</span>
          </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveGrpCnt('edit')">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-size-small"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editGrpConNameDetails" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel6">
          Edit Contact Name
          <button type="button" class="close" id="closeEditGrpConNameDetails" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-grroup col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-0">
            <label class="label-control font-weight-bold" for="editGrpConFname">First Name<span
                class="text-error">*</span></label>
            <input type="text" autocomplete="off" class="form-control form-control-sm" id="editGrpConFname" [(ngModel)]="editGrpConFname"
              (keyup)="GrpEditCntemptyCheck('Fname')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpEditContact('Fname')"
                (keydown.enter)="resetGrpEditContact('Fname')"
                (keydown.space)="resetGrpEditContact('Fname')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConFnameError==true">Please Enter the First Name.</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-0">
            <label class="label-control font-weight-bold" for="editGrpConLname">Last Name<span
                class="text-error">*</span></label>
            <input type="text" class="form-control form-control-sm" id="editGrpConLname" [(ngModel)]="editGrpConLname"
              (keyup)="GrpEditCntemptyCheck('Lname')">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear">
              <button type="button" class="ng-clear cancel"
                (click)="resetGrpEditContact('Lname')"
                (keydown.enter)="resetGrpEditContact('Lname')"
                (keydown.space)="resetGrpEditContact('Lname')" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="GrpConLnameError==true">Please Enter the Last Name.</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="editGrpConDetails('name')">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="EditGrpConRole" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel7">
          Edit Group Role
          <button type="button" class="close" id="closeEditGrpConRole" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body pb-1">
        <div class="mb-3 pl-3"> <span class="font-weight-bold">Group : </span> {{ groupName ? groupName : '' }} </div>

        <div class="mb-3 pl-3"> <span class="font-weight-bold">Name : </span> {{ GrpConFname ? GrpConFname : '' }} {{
          GrpConLname ? GrpConLname : '' }}</div>

        <div class="mb-3 pl-3"> <span class="font-weight-bold">Email : </span> {{ GrpConEmail ? GrpConEmail : '' }}
        </div>

        <div class="mb-3 pl-3" *ngIf="CmpConIpn!='' "> <span class="font-weight-bold">IPN : </span> {{ GrpConIpn ?
          GrpConIpn : '' }} </div>

        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12">
            <mat-label class="label-control font-weight-bold">Role
            </mat-label>
            <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="GrpConRole"
              (selectionChange)="GrpCntRoleSelected($event)" panelClass="dropdown-panel"
              [disableOptionCentering]="true">
              <ng-container *ngIf="PersonRoleSelectOp.length>0"></ng-container>
              <mat-option *ngFor="let pRole of PersonRoleSelectOp"
                [value]="pRole.rowId">{{pRole.roleTypeLabel}}</mat-option>
            </mat-select>
            <span class="text-error" *ngIf="GrpConRoleError==true">Please Select the Role.</span>
          </div>
        </section>
      </div>


      <div class="modal-footer border-0 m-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-red btn-red-bg btn-margin-right-160"
            data-toggle="modal" data-target="#groupContactRemoveModalPopup"
            *ngIf="roleVariableHide || superUserShow || roleIsManager || showBuyerProfile==false">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete
              Role</span></button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="AddEditSaveGrpCnt('edit')">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-size-small"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="groupContactRemoveModalPopup" tabindex="-1" aria-modal = "true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel8">
          Remove Role for this Group
          <button type="button" class="close" id="closeRCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="label-control label-15-bold">Do you want to remove this role for
              this Group? </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-red-bg"
            (click)="delRole()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{removeDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="DeleteContact" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel9">
          Delete Contact
          <button type="button" class="close" id="closeDelCont" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="label-control label-14-bold-mb7"> Do you want to
              delete this contact?</p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue bg-cb4b32"
            (click)="delContact()">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right"> Delete </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupAliasDeleteModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel10">
          Delete Group Alias by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeGAliasDelBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="label-control label-15-bold">Do you want to delete this
              {{aliasTypesArchive}} Alias? </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm bg-red" (click)="deleteGroupAlias()">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupAliasRemoveModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel11">
          Archive Group Alias by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeGAliasArBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="label-control label-15-bold">Do you want to archive this
              {{aliasTypesArchive}} Alias? </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue bg-red" (click)="archiveGroupAlias()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{archiveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupPanelRemoveModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel12">
          Archive CC by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeGPRBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="label-control label-15-bold">Do you want to archive this CC for
              this Group? </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="removeGroupPanle()">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon><span class="float-right">{{archiveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningForArchiveGrp" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-margin-left-neg4">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel13">
          Warning
          <button type="button" class="close" id="closeArchiveCpy" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              Prior to archive a Group, please archive or move all its Companies.
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupStatusModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel14">
          Change group status by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeGSBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">Group Status
            </mat-label>
            <mat-select class="form-control form-control-sm" [(ngModel)]="groupStatusModelval"
              (selectionChange)="checkGSvalidateField()" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option *ngIf="groupModificationStatus!='VALIDATED'" value="VALIDATED">Active</mat-option>
              <mat-option *ngIf="groupModificationStatus!='ARCHIVED'" value="ARCHIVED">Archived</mat-option>
            </mat-select>
            <span class="text-error" *ngIf="groupStatusModelvalerror==true">Please select status!!!</span>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateGroupStatus()"
            [disabled]="disableEditGrpStatusBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupnameModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel15">
          Change group name by <span class="label-orange">Admin</span>
          <button type="button" class="close" id="closeBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="editGroupNameId">Group Name
            </label>
            <input type="text" [attr.maxLength]="maxGrpLength" id="editGroupNameId" class="form-control form-control-sm"
              [(ngModel)]="groupNameModelval"
              (keyup)="
              checkvalidateCompanyNameField(groupNameModelval,'groupNameModelval','groupNameModelvalerror','groupNameModelvalRegExerror')"
              (ngModelChange)="groupNameModelval = $event.toUpperCase()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button" class="ng-clear cancel"
                (click)="resetSelectedFields()"
                (keydown.enter)="resetSelectedFields()"
                (keydown.space)="resetSelectedFields()" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="groupNameModelvalerror==true">Please enter group name!!!</span>
            <span class="text-error" *ngIf="groupNameModelvalRegExerror==true">A-Z 0-9 space () . , - /</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateGroupName()"
            [disabled]="disableEditGrpName==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupUpdateCode" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel22">
          Change group category by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeGroupTypebtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">Group Category
            </mat-label>
            <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="groupTypeCodeModel"
              panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option *ngFor="let vals of groupTypeCodeData" [value]="vals">{{vals}}</mat-option>
            </mat-select>
            <span class="text-error" *ngIf="groupCategoryTypeCode==true">Please select category code!!!</span>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateGroupTypeCodeFn()"
            [disabled]="disableEditGrpCategory==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupAliasModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom" *ngIf="showThisModal=='default'">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel23">
          Add Group Identifiers
          <button type="button" class="close" id="closeGABtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            *ngIf="groupIdentifierKeys.length>0">
            <mat-label class="label-control">Type
            </mat-label>
            <mat-select class="form-control form-control-sm" [(ngModel)]="groupIdentifierModelval"
              (change)="checkvalidateGroupIdentiTypeField()">
              <mat-option *ngFor="let groupIdentifierKey of groupIdentifierKeys"
                [value]="groupIdentifierKey.row_id">{{groupIdentifierKey.name}}</mat-option>
            </mat-select>

            <span class="text-error" *ngIf="groupIdentifierModelvalerror==true">Please select type!!!</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="groupIdentifierValueUp">Value
            </label>
            <input type="text" id="groupIdentifierValueUp" class="form-control form-control-sm"
              [(ngModel)]="groupIdentifierValModelval" (keyup)="checkvalidateGroupIdentiValField()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button" class="ng-clear cancel"
                (click)="resetSelectedIdentifierValFields()"
                (keydown.enter)="resetSelectedIdentifierValFields()"
                (keydown.space)="resetSelectedIdentifierValFields()" tabindex="0">×</button>
            </span>
            <span class="text-error" *ngIf="groupIdentifierValModelvalerror==true">Please enter value!!!</span>
            <span class="text-error" *ngIf="addAliasCharacterError==true">Max Character For MDM Alias is
              6!!!</span>
          </div>
          <span *ngIf="groupIdentifierKeys.length<=0">
            <img src="assets/images/loading.gif" alt="loading...">
          </span>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0" *ngIf="groupIdentifierKeys.length>0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="checkIfGroupAliasExist()"
            [disabled]="disableAddGroupAliasBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
  <div class="modal-dialog modal-custom" *ngIf="showThisModal=='samegroup'">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel24">
          Add Group Alias
          <button type="button" class="close" id="closeGABtn4" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <span class="font-weight-bold" [innerHtml]="groupAliasInnerText">
            </span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal">{{modalButtonText}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="moveGroupProspectModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel25">
          Move CC by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeMPBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">Move Commodity Code</mat-label>
            <mat-select class="form-control form-control-sm" [(ngModel)]="moveGroupProspectModelval"
              (change)="checkGSvalidateField()">
              <mat-option value="In Panel">PANEL</mat-option>
              <mat-option value="Archived">ARCHIVED</mat-option>
            </mat-select>
            <span class="text-error" *ngIf="moveProspectValModelvalerror==true">Please select value!!!</span>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="moveCCbyAdmin()">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="CCModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel26">
          Add CC by <span class="label-orange">Admin</span>
          <button type="button" class="close" id="closeCCBtn5" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="commoditycodesearchinput">Commodity Code
            </label>

            <input class="form-control form-control-sm form-control-paddings"
              (ngModelChange)="this.userQuestionUpdate3.next($event)" autocomplete="off"
              [(ngModel)]="commodityCodeModelvalLabel"  type="text"  list="staticUserIdsAddCC"
              id="commoditycodesearchinput" (change)="setidentifierNameModel();" />
            <datalist id="staticUserIdsAddCC">
              <option *ngFor="let commodityCode of commodityCodesSearch">{{commodityCode.code_label}}</option>
            </datalist>

            <span class="text-error" *ngIf="commodityCodeModelvalerror==true">Please select valid commodity
              code</span>
          </div>

          <span *ngIf="commoditycodeloaded==true">
            <img src="assets/images/loading.gif" alt="loading...">
          </span>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateCommodityCode()">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="commodityDetailsModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel28">
          CC: {{commodityCodeDetailsByRow.code}}
          <button type="button" class="close" id="closeComDBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            class="commodity-details-container">
            <ul
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 nav flex-column list-view mt-12 p-0 section-scroll word-break">
              <li class="commodity-details-list" _ngcontent-c0="">
                <span class="commodity-details-label">Commodity Name&nbsp;:&nbsp;</span><span
                  [innerHtml]="commodityCodeDetailsByRow.label"></span>
              </li>
              <li class="commodity-details-list" _ngcontent-c0="">
                <span class="commodity-details-label">Commodity Description&nbsp;:&nbsp;</span>
                <div [innerHtml]="commodityCodeDetailsByRow.description"></div>
              </li>
              <li class="commodity-details-list" _ngcontent-c0="">
                <span class="commodity-details-label">Commodity Type&nbsp;:&nbsp;</span><span
                  *ngIf="commodityTypeFlag==false"> <img src="assets/images/loading.gif" alt="Updating..."></span><span
                  *ngIf="commodityTypeFlag==true && commodityTypes != undefined && commodityTypes != ''"
                  class="commodity-details-list">{{commodityTypes}}</span>
              </li>
              <li class="commodity-details-list" _ngcontent-c0="">
                <span class="commodity-details-label">FSA&nbsp;:&nbsp;</span><span
                  *ngIf="fsaCodeFlag==false"> <img src="assets/images/loading.gif" alt="Updating..."></span><span
                  *ngIf="fsaCodeFlag==true && fsaCDataList != undefined && fsaCDataList != ''"
                  class="commodity-details-bold label-orange"> {{fsaCDataList.slice(0, -2)}}</span>
              </li>
              <li class="commodity-details-list" _ngcontent-c0="">
                <span class="commodity-details-label">PANEL&nbsp;:&nbsp;</span><span
                  *ngIf="panelCodeFlag==false"> <img src="assets/images/loading.gif" alt="Updating..."></span><span
                  *ngIf="panelCodeFlag==true && panelCDataList != undefined && panelCDataList != ''"
                  class="commodity-details-bold label-orange"> {{panelCDataList.slice(0,
                  -2)}}</span>
              </li>
            </ul>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupingStatusModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel27">
          Change Grouping Status by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closeGISBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">Grouping Status
            </mat-label>
            <mat-select class="form-control form-control-sm" [(ngModel)]="groupingStatusModelval"
              (change)="checkGISvalidateField()">
              <mat-option *ngIf="groupingStatusExistsModelval!='ACTIVE'" value="ACTIVE">Active</mat-option>
              <mat-option *ngIf="groupingStatusExistsModelval!='ARCHIVED'" value="ARCHIVED">Archived</mat-option>
              <mat-option *ngIf="groupingStatusExistsModelval!='BLOCKED'" value="BLOCKED">Inactive</mat-option>
            </mat-select>
            <span class="text-error" *ngIf="groupingStatusModelvalerror==true">Please select grouping
              status!!!</span>
          </div>

        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="updateGroupingStatus()">
            <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span
              class="float-right">{{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showSelectCountryId" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-margin-left-9pct">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel29">
          Select Country
          <button type="button" class="close" id="closeshowSelectCountryId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-select class="form-control" name="countrySelect" id="" [(ngModel)]="selectedCustomCountry">
              <mat-option value="{{coun}}" *ngFor="let coun of countrySelList">{{coun}}</mat-option>
            </mat-select>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"
            (click)="checkSelRunSite()"> OK </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWarningCheckGrp" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel30">
          Warning
          <button type="button" class="close" id="closeshowWarningCheckGrp" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p>{{showCheckGrpWarningMsg}}</p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openEditBvdModal" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel31">
          Edit BVD ID by <span class="label-orange">ADMIN</span>
          <button type="button" class="close" id="closebvdmodal" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control" for="editBvdIdInput">BVD ID
            </label>
            <input class="input-padding-2 form-control form-control-sm form-control-paddings" id="editBvdIdInput"
              [(ngModel)]="editBvdIdValueModel" type="text"
              (keyup)="checkForBvdId(editBvdIdValueModel,'editBvdIdValueModel','editBvdIdModalError')"
              (ngModelChange)="editBvdIdValueModel = $event.toUpperCase()" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                class="ng-clear ng-clear-bg-white cancel" (click)="resetBvdId('bvdid')"
                (keydown.enter)="resetBvdId('bvdid')"
                (keydown.space)="resetBvdId('bvdid')"
                tabindex="0">&times;</button></span>
            <span class="text-error" *ngIf="editBvdIdModalError==true">Please Enter Bvd Id!!!</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 w-100">
          <button type="button" class="btn btn-custom btn-custom-sm mr-1 bg-ec051d"
            (click)="openCnfArchiveModal('delete')">
            <mat-icon svgIcon="delete" class="img-btn mr-2"></mat-icon><span class="float-right">Delete</span>
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveModal('archive')"
            *ngIf="showArchivedBvdId==false">
            Archive
          </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="openCnfArchiveModal('unarchive')"
            *ngIf="showArchivedBvdId==true">
            Unarchive
          </button>
          <article class="float-right">
            <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
            <button type="button" class="btn btn-custom btn-custom-sm btn-blue" [disabled]="disableSaveBvdBtn==true"
              (click)="saveBvdId()">
              <mat-icon svgIcon="mail" class="img-btn mr-2 icon-white"></mat-icon><span class="float-right">
                Save </span>
            </button>
          </article>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfArchiveBvdId" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel33">
          Archive BVD ID
          <button type="button" class="close" id="closeCnfArchiveBvdId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            Do you want to archive this BVD ID ?
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 ">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="archiveBvDID()">
            Archive
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfDeleteBvdId" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel34">
          Delete BVD ID
          <button type="button" class="close" id="closeCnfDeleteBvdId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            Do you want to Delete this BVD ID ?
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 ">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="DeleteBvDID()">
            Delete
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade mt-4" id="CnfUnArchiveBvdId" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel35">
          Unarchive BVD ID
          <button type="button" class="close" id="closeCnfUnArchiveBvdId" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            Do you want to unarchive this BVD ID ?
          </div>
        </section>
      </div>

      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 ">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UnarchiveBvDID()">
            Unarchive
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showBvdIdStatus" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel36">
          Warning
          <button type="button" class="close" id="closeNoShortNameOrCity" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              {{bvdIdStatusText}}
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> OK </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWorkflowValidation" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel37">
          Workflow Validation
          <button type="button" class="close" id="closeWorkflowValidation" #closeBtn data-dismiss="modal"
            aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="wkfValNotes"> NOTES :</label>
            <textarea class="form-control form-control-sm" id="wkfValNotes" [(ngModel)]="wkfValNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button" class="ng-clear cancel"
                (click)="resetWkfValNotesModel()"
                (keydown.enter)="resetWkfValNotesModel()"
                (keydown.space)="resetWkfValNotesModel()" tabindex="0">×</button>
            </span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div *ngIf="validatingWorkflow" class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" [disabled]="validatingWorkflow">
            Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="validateWkfNoteRoute()"
            [disabled]="workflowValidationLoading==true">

            <div class="icon-text-container">
              <mat-icon svgIcon="confirm" alt="greentick" class="rounded-circle svg-icon icon-padding-2">
              </mat-icon>
              <span>Validate</span>
            </div>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showWorkflowRejection" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel21">
          Reject The Request
          <button type="button" class="close" id="closeWorkflowRejection" #closeBtn data-dismiss="modal"
            aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="wkfRejNotes"> NOTES :<span class="element_astrick">*</span></label>
            <textarea class="form-control form-control-sm" id="wkfRejNotes" [(ngModel)]="wkfRejNotesModel" (keyup)="checkCommentsField()"
              maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton cancel" title="Clear all">
              <button type="button" class="ng-clear"
                (click)="resetWkfRejNotesModel()"
                (keydown.enter)="resetWkfRejNotesModel()"
                (keydown.space)="resetWkfRejNotesModel()" tabindex="0" >×</button>
            </span>
            <span class="text-error" *ngIf="rejectWorkflowNotesError==true">Please Enter Notes inorder to reject a
              workflow!!!</span>
          </div>
          <div *ngIf="validatingWorkflow" class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            [disabled]="validatingWorkflow==true"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-reject"
            class="btn btn-custom btn-custom-sm btn-red" (click)="rejectWkfNoteRoute()"
            [disabled]="workflowValidationLoading==true">
            <mat-icon class="mr-2 icon-height-18" svgIcon="less"></mat-icon><span class="float-right">
              Reject </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="showWorkflowInfoRequest" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel20">
          More Information Request
          <button type="button" class="close" id="closeWorkflowInfoRequest" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold" for="wkfInfoNotes"> NOTES :</label>
            <textarea class="form-control form-control-sm" id="wkfInfoNotes" [(ngModel)]="wkfInfoNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button" class="ng-clear cancel"
                (click)="resetWkfInfoNotesModel()"
                (keydown.enter)="resetWkfInfoNotesModel()"
                (keydown.space)="resetWkfInfoNotesModel()" tabindex="0">×</button>
            </span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="infoWkfNoteRoute()"
            [disabled]="workflowValidationLoading==true">
            <mat-icon svgIcon="info" class="icon-size-info rounded-circle"></mat-icon><span class="float-right pl-2"> Request </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade mt-4" id="notesHistory" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-width-800">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel19">
          Workflow History
          <button type="button" class="close" id="closeNotesHistory" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive" *ngIf="requestForNotesHistory">
        <div class="modal-title font-weight-bold mx-4 mt-3">
          <h6 class="font-weight-bold">Request Id: <span class="text-60504a">{{ requestForNotesHistory ?
              requestForNotesHistory['requestId'] : '' }}</span></h6>
        </div>
        <h6 class="font-weight-bold mx-4 mb-2">Requestor: <span *ngIf="requestForNotesHistory['requestor']"><a
              href="mailto:{{requestForNotesHistory['RequestorMailId']}}?
              subject=ISA - {{requestForNotesHistory['requestId']}} / {{requestForNotesHistory['supplierName']}}"
              class="text-underline-47525e">{{requestForNotesHistory['requestor']['displayName']}}</a></span>
        </h6>
        <h6 class="font-weight-bold mx-4 mb-2" *ngIf="requestForNotesHistory['approver']">Approver: <span
            class="font-lighter" [ngStyle]="approverColor(requestForNotesHistory['workflowOwnerWithRole'])">{{
            requestForNotesHistory ? requestForNotesHistory['approver'] : '' }}</span></h6>
        <div class="modal-title font-weight-bold mx-4 mt-3">
          <h6 class="font-weight-bold">Status:<span class="group-status px-3 mr-1"
              [ngStyle]="{'background':colorForWorkflow[requestForNotesHistory['status']],'min-width': '82px'}"
              class="white-space-nowrap">{{ requestForNotesHistory ? requestForNotesHistory['status'] : '' }}</span>
          </h6>
        </div>
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline"
                (click)="sort('requestor')"
                (keydown.enter)="sort('requestor')"
                (keydown.space)="sort('requestor')" tabindex="0">User</th>
              <th class="sortDecorationunderline"
                (click)="sort('role')"
                (keydown.enter)="sort('role')"
                (keydown.space)="sort('role')" tabindex="0">Role</th>
              <th class="sortDecorationunderline"
                (click)="sort('validation')"
                (keydown.enter)="sort('validation')"
                (keydown.space)="sort('validation')" tabindex="0">Validation</th>
              <th class="sortDecorationunderline th-width-20"
                (click)="sort('notes')"
                (keydown.enter)="sort('notes')"
                (keydown.space)="sort('notes')" tabindex="0">Notes</th>
              <th class="sortDecorationunderline"
                (click)="sort('date')"
                (keydown.enter)="sort('date')"
                (keydown.space)="sort('date')" tabindex="0">Date</th>
            </tr>
          </thead>
          <tbody *ngIf="requestForNotesHistory">
            <ng-container
              *ngFor="let detail of requestForNotesHistory['historys'] | orderBy: key:reverse; let i = index">
              <tr class="col forColor p-0">
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.requestor}}
                </td>
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.role ?
                  detail.role : '-'}}</td>
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                  <mat-icon *ngIf="detail.route == 'OK'" svgIcon="confirm" alt="greentick"
                    class="rounded-circle svg-icon green icon-padding-2"></mat-icon>
                  <mat-icon *ngIf="detail.route == 'KO'" svgIcon="less" alt="redClose" class="rounded-circle red icon-padding-2"></mat-icon>
                  <mat-icon *ngIf="detail.route == 'More info needed'" svgIcon="information" class="info-color icon-padding-2"></mat-icon>

                  <img src="assets/images/Submitted.png" alt="Submitted" class="rounded-circle"
                    *ngIf="detail.route == 'Submitted'">
                </td>
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-left"
                  class="line-break-anywhere">{{detail.comment ? detail.comment : '-'}}</td>
                <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.date ?
                  (detail.date | date:'yyyy-MM-dd') : '-'}}</td>
              </tr>
            </ng-container>
          </tbody>
          <tbody *ngIf="requestForNotesHistory.length==0">
            <tr>
              <td colspan="7" class="font-weight-bold label-darkblue text-center">No Results</td>
            </tr>
          </tbody>
          <ng-container *ngIf="loading">
            <div class="local-loading-overlay">
              <div class="custom-spinner-template">
                <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
              </div>
            </div>
          </ng-container>
          <tfoot [hidden]="this.history">
            <tr>
              <td colspan="8">
                <ul *ngIf="histPager.pages && histPager.pages.length" class="pagination">
                  <li [ngClass]="{disabled:histPager.currentPage === 1}">
                    <a (click)="historyTable(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(1))">First</a>
                  </li>
                  <li [ngClass]="{disabled:histPager.currentPage === 1}">
                    <a (click)="historyTable(histPager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(histPager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of histPager.pages" [ngClass]="{active:histPager.currentPage === page}">
                    <a (click)="historyTable(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(page))">{{page}}</a>
                  </li>
                  <li [ngClass]="{disabled:histPager.currentPage === histPager.totalPages}">
                    <a (click)="historyTable(histPager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(histPager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{disabled:histPager.currentPage === histPager.totalPages}">
                    <a (click)="historyTable(histPager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (historyTable(histPager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal"
            id="closeCatAuthState">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningBvdportfolio" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9-neg">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel18">
          Warning
          <button type="button" class="close" id="closeupdateaddbvdid" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              {{groupName}} seems to have its BvD ID {{sitebvidid}} changed to {{bvdidNumber}}. Do you want to update it
              before adding it into the Portfolio ?
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="UpdateaddBvDID()"> Update/add
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="openWarningbvdnotpresentinOrbis" tabindex="-1" aria-modal = "true"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9-neg">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel17">
          Warning
          <button type="button" class="close" id="closeupdateaddbvdid2" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              This BvD ID {{sitebvidid}} does not exist in Orbis Database. Please check it before retrying again.
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> Ok </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="d-none">
  <button id="btnForWarningArchiveGrp" data-target="#openWarningForArchiveGrp" data-toggle="modal"></button>
  <button id="btnForSelectCountryId" data-target="#showSelectCountryId" data-toggle="modal"></button>
  <button id="brnForWarningCheckGrp" data-target="#showWarningCheckGrp" data-toggle="modal"></button>
  <button id="btnForCnfArchive" data-target="#CnfArchiveBvdId" data-toggle="modal"></button>
  <button id="btnForCnfUnArchive" data-target="#CnfUnArchiveBvdId" data-toggle="modal"></button>
  <button id="btnForDeleteBvd" data-target="#CnfDeleteBvdId" data-toggle="modal"></button>
  <button id="btnForBvdIdStatus" data-target="#showBvdIdStatus" data-toggle="modal"></button>
  <button id="btnForWarningBvdportfolio" data-target="#openWarningBvdportfolio" data-toggle="modal"></button>
  <button id="btnForbvdnotpresentinOrbis" data-target="#openWarningbvdnotpresentinOrbis" data-toggle="modal"></button>
  <button id="btnForDocumentValidation" data-target="#documentValidationModal" data-toggle="modal"></button>
  <button id="btnForQualifierValidation" data-target="#qualifierValidationModal" data-toggle="modal"></button>
</div>

<!-- Document Validation Modal -->
<div id="documentValidationModal" class="modal fade" tabindex="-1" aria-modal = "true"
aria-labelledby="documentValidationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header modal-header-beige">
        <h5 class="modal-title font-weight-bold text-center" id="documentValidationModalLabel">
          Document Validation Required
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-body-white">
        <div class="alert-box" role="alert">
          <strong>Missing Documents!</strong>
          <p class="mb-2">Please upload your documents to proceed with sending to buyer.</p>
          <p class="mb-0">At least one non-archived document is required in the documents section of the company.</p>
        </div>
        <div class="text-center">
          <a [href]="userGuideUrl"
             target="_blank"
             class="btn btn-brown">
            <i class="label"></i> User Guide
          </a>
        </div>
      </div>
      <div class="modal-footer">
        <button
        type="button" class="btn btn-brown-sm" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Qualifier Validation Modal -->
<div id="qualifierValidationModal" class="modal fade" tabindex="-1" aria-modal = "true"
aria-labelledby="qualifierValidationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header modal-header-beige">
        <h5 class="modal-title font-weight-bold text-center"  id="qualifierValidationModalLabel">
          <i class="label"></i> Qualifier Validation Required
        </h5>
        <button
        type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-body-white">
        <div class="alert" role="alert">
          <p class="mb-2">At least one qualifier (other than Main Entrance) must be present on at least one site of the company.</p>
          <p class="mb-0"><em>Note: Main Entrance qualifier alone is not sufficient for validation.</em></p>
        </div>
      </div>
      <div class="modal-footer">
        <button
        type="button" class="btn btn-brown-sm" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
